// Webpack 4 (used by the previous CRA/react-scripts build) auto-polyfilled
// Node's `Buffer` and `global` for the browser bundle; a few transitive
// deps (e.g. react-tooltip -> sanitize-html-react -> htmlparser2) rely on
// them existing at runtime. Vite doesn't do this automatically, and
// vite-plugin-node-polyfills's own `globals` preamble-injection option is
// unsafe here: it collides with libraries (e.g. material-ui's JSS
// internals) that declare their own module-scoped `var globalThis`, so we
// polyfill once, ourselves, at the real application entry point instead.
import { Buffer } from 'buffer';

if (typeof globalThis.Buffer === 'undefined') {
    globalThis.Buffer = Buffer;
}

if (typeof globalThis.global === 'undefined') {
    globalThis.global = globalThis;
}
